export const environment = {
    production: false,
    apiBaseUrl: 'https://avatiproapiteste.avatisistemas.com',
    wsUrl: 'https://avatiproapiteste.avatisistemas.com/ws',
    imgHost: 'https://avatiproapitesteimg.avatisistemas.com',//'https://avatiproapitesteimg.avatisistemas.com/
    applicationName: 'Vendas Homolog',

    // Firebase Web App (Google Auth + Cloud Messaging)
    firebase: {
      apiKey: 'AIzaSyDWdUDrIX2SIsTKF9R9tkerf8-JhbRzSpc',
      authDomain: 'avati-vendas.firebaseapp.com',
      projectId: 'avati-vendas',
      messagingSenderId: '638087310894',
      appId: '1:638087310894:web:dde4fc0ddad9fd176ab9bf',
      vapidKey: 'BIIQEyxEGRnMku1KHafIgifRL7zdPJ6fkBRQH8KwYOcTE7L6GASOwGkDNBXKyNWJxjfK7DNoahHO0ysfcFm3rTI',
    },

    // Google Sign-In
    google: {
      clientId: '638087310894-e3tppepj7pmrmcsg2fpe0gdvns3io9g0.apps.googleusercontent.com',
    },

    // Apple Sign-In (TODO: configurar quando tiver Apple Developer Account)
    apple: {
      clientId: 'APPLE_SERVICE_ID',
      redirectURI: 'https://localhost:4200/api/apple/callback',
    },
  };
